import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { lazy, Suspense, useEffect, useState } from "react";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnWindowFocus: false, staleTime: 1000 * 60 * 1 },
    },
});

// Connect query client to tanstack extension for debugging
declare global {
    interface Window {
        __TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
    }
}

// eslint-disable-next-line no-underscore-dangle
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const ReactQueryDevtoolsProduction = lazy(() =>
    import("@tanstack/react-query-devtools/production").then((d) => ({
        default: d.ReactQueryDevtools,
    })),
);

export const WithReactQuery = ({ children }: { children: React.ReactNode }) => {
    const [showProductionDevtools, setShowProductionDevtools] = useState(false);

    useEffect(() => {
        window.toggleDevTools = () => setShowProductionDevtools((old) => !old);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            <Suspense fallback={null}>
                <ReactQueryDevtools buttonPosition="top-right" />
            </Suspense>
            {showProductionDevtools && <ReactQueryDevtoolsProduction />}
        </QueryClientProvider>
    );
};
